import { usePTPConfigContext } from 'GlobalConfig.context';
import { Stack } from 'components/Stack';
import { useDetectDevice } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Section } from '../../../Section';
import { LineItems } from '../../../LineItems';
import {
  AdditionalContainer,
  AdditionalInformation,
} from './ReturnDetails.styles';
import { CommentSection } from './components/CommentSection';
import { AttachmentSection } from './components/AttachmentSection';
import { ReturnShipment } from '../../models/ReturnShipment.model';

interface ReturnDetailsProps {
  shipment: ReturnShipment;
}

export const ReturnDetails = ({
  shipment,
}: ReturnDetailsProps): JSX.Element => {
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();

  const { lineItem: lineItemConfig, return: returnConfig } =
    usePTPConfigContext();
  const title =
    returnConfig?.returnDetails?.sectionTitle || t('RETURN_RETURN_DETAILS');

  const { hideComment, hideUpload } = returnConfig.formSection;

  return (
    <>
      {lineItemConfig.isEnabled && (
        <Stack direction="column" gap={16}>
          <Section block title={title}>
            <LineItems lineItems={shipment.lineItems} />
          </Section>
          {hideComment && hideUpload ? (
            <></>
          ) : (
            <Section block>
              <AdditionalContainer isMobile={isMobile}>
                <AdditionalInformation direction={isMobile ? 'column' : 'row'}>
                  {!hideComment && (
                    <CommentSection comment={shipment.returnTicket.comment} />
                  )}
                  {!hideUpload && (
                    <AttachmentSection
                      attachments={shipment.returnTicket.returnProofs}
                    />
                  )}
                </AdditionalInformation>
              </AdditionalContainer>
            </Section>
          )}
        </Stack>
      )}
    </>
  );
};
